import { render, staticRenderFns } from "./DialogAssignTeacher.vue?vue&type=template&id=1dbaa3dd"
import script from "./DialogAssignTeacher.vue?vue&type=script&lang=js"
export * from "./DialogAssignTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports